import React, { useState } from "react";
import { StldInput } from '../../styled-components/StyledInput.style';



// export const DynamicInputAntigo = ({ type, placeholder, label, name, value, register, color = null, componentReadOnly = false, paramMethod = null, disabled=false }) => {
//     const [focused, isFocused] = useState(null);
//     return (
//         <StldInput color={color} onMouseEnter={() => isFocused(name)} onMouseLeave={() => isFocused(null)} >
//             <label className="focused">{label}</label>
//             {!!paramMethod ?
//             !!register ? (
//                 <input {...register(name, { required: false })} type={type} disabled={disabled} readOnly={componentReadOnly} placeholder={placeholder} name={name} value={value === null || typeof value === 'undefined' ? '' : value} onChange={(event) => paramMethod(event.target.value)} />
//             ) : (
//                 <input type={type} disabled={disabled} readOnly={componentReadOnly} placeholder={placeholder} name={name} value={value === null || typeof value === 'undefined' ? '' : value} onChange={(event) => paramMethod(event.target.value)} />
//             )
//             : !!register ? (
//                 <input {...register(name, { required: false })} type={type} disabled={disabled} readOnly={componentReadOnly} placeholder={placeholder} name={name} value={value === null || typeof value === 'undefined' ? '' : value} />
//             ) : (
//                 <input type={type} disabled={disabled} readOnly={componentReadOnly} placeholder={placeholder} name={name} value={value === null || typeof value === 'undefined' ? '' : value} />
//             )}

//         </StldInput>
//     )
// }

export const DynamicInput = ({ type, placeholder, label, name, value, register, color = null, componentReadOnly = false, paramMethod = null, disabled=false }) => {
    const [focused, isFocused] = useState(null);

    // O SEGREDO ESTÁ AQUI:
    // Se o valor for null ou undefined, passamos undefined para que o React não trave o input em "".
    const safeValue = (value === null || typeof value === 'undefined') ? undefined : value;

    // Extraímos as propriedades do register antes para podermos mesclar os eventos sem erro
    const reg = register ? register(name, { required: false }) : null;

    return (
        <StldInput color={color} onMouseEnter={() => isFocused(name)} onMouseLeave={() => isFocused(null)} >
            <label className="focused">{label}</label>

            {!!paramMethod ? 
                !!register ? (
                    // CASO 1: TEM PARAMMETHOD e TEM REGISTER (Aqui estava o problema!)
                    <input 
                        {...reg} 
                        type={type} 
                        disabled={disabled} 
                        readOnly={componentReadOnly} 
                        placeholder={placeholder} 
                        name={name} 
                        value={safeValue} 
                        onChange={(event) => {
                            // 1. Aciona o react-hook-form para ele não se perder no estado
                            if (reg && reg.onChange) {
                                reg.onChange(event);
                            }
                            // 2. Aciona o seu método customizado da tela
                            paramMethod(event.target.value);
                        }} 
                    />
                ) : (
                    // CASO 2: TEM PARAMMETHOD, SEM REGISTER
                    <input 
                        type={type} 
                        disabled={disabled} 
                        readOnly={componentReadOnly} 
                        placeholder={placeholder} 
                        name={name} 
                        value={safeValue} 
                        onChange={(event) => paramMethod(event.target.value)} 
                    />
                )
            : 
                !!register ? (
                    // CASO 3: SEM PARAMMETHOD, COM REGISTER (Os "Normais" que funcionaram pra você)
                    <input 
                        {...reg} 
                        type={type} 
                        disabled={disabled} 
                        readOnly={componentReadOnly} 
                        placeholder={placeholder} 
                        name={name} 
                        value={safeValue} 
                    />
                ) : (
                    // CASO 4: SEM PARAMMETHOD e SEM REGISTER
                    <input 
                        type={type} 
                        disabled={disabled} 
                        readOnly={componentReadOnly} 
                        placeholder={placeholder} 
                        name={name} 
                        value={safeValue} 
                    />
                )
            }
        </StldInput>
    )
}

export const DynamicInput2 = ({
    type,
    placeholder,
    label,
    name,
    value,
    register,
    color = null,
    componentReadOnly = false,
    paramMethod = null,
    disabled = false,
    min = null,
    className = "",
    onKeyDown = null,
    ...props
}) => {
    const [focused, isFocused] = useState(null);
    const commonProps = {
        type,
        disabled,
        readOnly: componentReadOnly,
        placeholder,
        name,
        value,
        min,
        className,
        onKeyDown,
        ...props
    };

    return (
        <StldInput color={color} onMouseEnter={() => isFocused(name)} onMouseLeave={() => isFocused(null)} >
            {/* <label className="focused">{label}</label> */}

            {!!paramMethod ?
                !!register ? (
                    <input
                        {...register(name, { required: false })}
                        {...commonProps}
                        onChange={(event) => paramMethod(event.target.value)}
                    />
                ) : (
                    <input
                        {...commonProps}
                        onChange={(event) => paramMethod(event.target.value)}
                    />
                )
            : !!register ? (
                <input
                    {...register(name, { required: false })}
                    {...commonProps}
                />
            ) : (
                <input
                    {...commonProps}
                />
            )}

        </StldInput>
    )
}